import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-top-copy",
  "use": "icon-arrow-top-copy-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1000 1000\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-top-copy\"><path d=\"M395.97916667 167.3125l-312.5 312.5c-24.4063 24.4063-24.4063 63.9688 0 88.375l312.5 312.5c24.4063 24.4063 63.9688 24.4063 88.375 0 24.4063-24.4063 24.4063-63.9688 0-88.375l-205.8125-205.8125 599.125 0c34.5313 0 62.5-27.9688 62.5-62.50000001s-27.9688-62.5-62.49999999-62.49999999l-599.12500001 0 205.8125-205.8125c12.1875-12.1875 18.31250001-28.1875 18.3125-44.1875s-6.0938-32-18.3125-44.1875c-24.4063-24.4063-63.9688-24.4063-88.375 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-top-copy.svg
// module id = 8Tmg
// module chunks = 12